<template>
    <section>
        <div class="ss-breadcrumb">
            <div class="container-hts">
                <ul class="margin-0 p-0">
                    <li><router-link to="/soan-tai-lieu">Soạn tài liệu</router-link></li>
                    <li><router-link to="/soan-tai-lieu?tab=3">Soạn kế hoạch bài dạy</router-link></li>
                    <li><router-link to="/soan-tai-lieu?tab=3&tabChild=1">Kế hoạch bài dạy đang giao</router-link></li>
                    <li><router-link to="">{{ nameLecture }}</router-link></li>
                </ul>
            </div>
        </div>
        <div class="container">
            <div class="name-leson mt-3">
                <h4>
                    <strong>{{ nameLecture }}</strong>
                </h4>
            </div>
            <b-tabs pills>
                <b-tab @click="handleOnChangeTab(TabContent)" title="Nội dung kế hoạch bài dạy"
                    :active="tabActive == TabContent">
                    <TabContentLessonPlaningDelived v-if="tabActive == TabContent" />
                </b-tab>
                <!-- <b-tab @click="handleOnChangeTab(TabFile)" title="Tài liệu đính kèm" :active="tabActive == TabFile">
                    <TabAttachmentLessonPlaningDelived :type="PLANING_LESSON_WAREHOUSE"
                        :dataElectronicLecture="dataElectronicLecture" v-if="tabActive == TabFile" />
                </b-tab> -->
    
                <b-tab @click="handleOnChangeTab(TabLearningTask)" title="Nhiệm vụ học tập"
                    :active="tabActive == TabLearningTask">
                    <LearningTask v-if="tabActive == TabLearningTask" />
                </b-tab>
                <b-tab @click="handleOnChangeTab(TabClass)" title="Danh sách lớp được giao" :active="tabActive == TabClass">
                    <ListLessonPlaningDelivered v-if="tabActive == TabClass" />
                </b-tab>
            </b-tabs>
        </div>
    </section>
</template>
<script>

import ListLessonPlaningDelivered from './_components/ListLessonPlaningDelivered'
import { PLANING_LESSON_WAREHOUSE,PLANING_LESSON_ASSIGN, ELECTRONIC_LECTURE_WAREHOUSE,ELECTRONIC_LECTURE_ASSIGN } from './../../constants/constants_enum'
import { getDetail } from './../../_api/LessonClassSchoolServices'
import TabContentLessonPlaningDelived from './_components/TabContentLessonPlaningDelived'
import LearningTask from './_components/LearningTask'
export default{
    components:{
        ListLessonPlaningDelivered,
        TabContentLessonPlaningDelived,
        LearningTask
    },
    data(){
        return {
            PLANING_LESSON_WAREHOUSE,PLANING_LESSON_ASSIGN, ELECTRONIC_LECTURE_WAREHOUSE,ELECTRONIC_LECTURE_ASSIGN ,
            tabActive:1,
            TabContent:1,
            TabFile:2,
            TabLearningTask:3,
            TabClass:4,
            paramQueryData: {
                id: 0,
                type: PLANING_LESSON_WAREHOUSE,
            },
            lessonClassSchoolId:0,
            dataElectronicLecture: {
                id: 0,
                name: '',
                bookTypeId: '',
                classId: '',
                subjectId: '',
                numberLesson: '',
                description: '',
                isPublic: false,
                type: PLANING_LESSON_WAREHOUSE
            },
            nameLecture: ''
        }
    },
    mounted(){
        this.nameLecture = this.$router.history.current.query.name
        this.paramQueryData.id = this.lessonClassSchoolId = this.$route.query.id
        this.getDetailLessonClassSchool()
    },
    methods:{
        handleOnChangeTab(tab){
            this.tabActive = tab
        },
        getDetailLessonClassSchool() {
            let self = this
            getDetail(this.lessonClassSchoolId).then(res => {
                if (res && res.data && !res.errors) {
                    self.dataElectronicLecture = {
                        id: res.data.id,
                        name: res.data.name,
                        bookTypeId: res.data.bookTypeId,
                        classId: res.data.classId,
                        subjectId: res.data.subjectId,
                        numberLesson: res.data.numberLesson,
                        description: res.data.description,
                        isPublic: res.data.isPublic,
                        type: res.data.type,
                    }
                }
            })
        },   
    }
}
</script>
<style>
.nav-pills{
    margin-bottom: 20px;
}
</style>